export const IS_LOADING = 'IS_LOADING';
export const ALERT_CLEAR = 'ALERT_CLEAR';
export const ALERT_LISTS = 'ALERT_LISTS';
export const ALERT_NOTIFICATION_UPDATE = 'ALERT_NOTIFICATION_UPDATE';
export const AUTH_SIGN_IN = 'AUTH_SIGN_IN';
export const AUTH_SIGN_OUT = 'AUTH_SIGN_OUT';
export const AUTH_REGISTER = 'AUTH_REGISTER';
export const AUTH_CHANGE_PASSWORD = 'AUTH_CHANGE_PASSWORD';
export const AUTH_FORGOT_PASSWORD = 'AUTH_FORGOT_PASSWORD';
export const AUTH_FORGOT_PASSWORD_VERIFY_OTP = 'AUTH_FORGOT_PASSWORD_VERIFY_OTP';
export const AUTH_FORGOT_PASSWORD_CHANGE = 'AUTH_FORGOT_PASSWORD_CHANGE';
export const AUTH_ADD_CONTACT = 'AUTH_ADD_CONTACT';
export const AUTH_ADD_CONTACT_VERIFY = 'AUTH_ADD_CONTACT_VERIFY';
export const AUTH_ADD_CONTACT_UPDATE = 'AUTH_ADD_CONTACT_UPDATE';
export const AUTH_CHANGE_CONTACT_DEFAULT = 'AUTH_CHANGE_CONTACT_DEFAULT';
export const AUTH_CLOST_ACCOUNT = 'AUTH_CLOST_ACCOUNT';
export const AUTH_CLEAR = 'AUTH_CLEAR';
export const COMPANIES_DATA = 'COMPANIES_DATA';
export const SMS_SEND_MSG = 'SMS_SEND_MSG';
export const SMS_SEND_OTP = 'SMS_SEND_OTP';
export const SMS_VERIFY_OTP = 'SMS_VERIFY_OTP';
export const SMS_CLEAR = 'SMS_CLEAR';
export const EMAIL_SEND_OTP = 'EMAIL_SEND_OTP';
export const EMAIL_VERIFY_OTP = 'EMAIL_VERIFY_OTP';
export const EMAIL_CLEAR = 'EMAIL_CLEAR';
export const FEEDBACK_SEND = 'FEEDBACK_SEND';
export const FEEDBACK_CLEAR = 'FEEDBACK_CLEAR';
export const MASTER_DATA = 'MASTER_DATA';
export const MASTER_DOCTOR_PREFIX = 'MASTER_DOCTOR_PREFIX';
export const MASTER_GROUP_SPECIALTIES = 'MASTER_GROUP_SPECIALTIES';
export const MASTER_TAGS_AND_EVENTS = 'MASTER_TAGS_AND_EVENTS';
export const MASTER_APPS = 'MASTER_APPS';
export const MASTER_MANUALS = 'MASTER_MANUALS';
export const MASTER_FAQS = 'MASTER_FAQS';
export const MASTER_SYMPTOM = 'MASTER_SYMPTOM';
export const MASTER_ORGAN = 'MASTER_ORGAN';
export const MASTER_ICD10 = 'MASTER_ICD10';
export const MASTER_UPDATE = 'MASTER_UPDATE';
export const MASTER_CLEAR = 'MASTER_CLEAR';
export const HOSPITAL_LISTS = 'HOSPITAL_LISTS';
export const HOSPITAL_DATA = 'HOSPITAL_DATA';
export const DOCTOR_UPDATE = 'DOCTOR_UPDATE';
export const DOCTOR_CREATE = 'DOCTOR_CREATE';
export const DOCTOR_FETCH_ONE = 'DOCTOR_FETCH_ONE';
export const DOCTOR_CLEAR = 'DOCTOR_CLEAR';
export const DOCTOR_GET_WALLET = 'DOCTOR_GET_WALLET';
export const DOCTOR_WALLET_HISTORY = 'DOCTOR_WALLET_HISTORY';
export const DRUG_FETCH = 'DRUG_FETCH';
export const MEDICAL_SUPPLY_FETCH = 'MEDICAL_SUPPLY_FETCH';
export const DRUG_CLEAR = 'DRUG_CLEAR';
export const MEDICAL_SUPPLY_CLEAR = 'MEDICAL_SUPPLY_CLEAR';
export const REFERRAL_FETCH = 'REFERRAL_FETCH';
export const REFERRAL_FETCH_ONE = 'REFERRAL_FETCH_ONE';
export const REFERRAL_LAST_FETCH = 'REFERRAL_LAST_FETCH';
export const REFERRAL_UPDATE = 'REFERRAL_UPDATE';
export const REFERRAL_CLEAR = 'REFERRAL_CLEAR';
export const REALTIME_DATA = 'REALTIME_DATA';
export const CHATS_CLEAR = 'CHATS_CLEAR';
export const CHATS_LIST = 'CHATS_LIST';
export const CHATS_SEND_MESSAGE = 'CHATS_SEND_MESSAGE';
export const PATIENT_GET_HEALTH_RECORD = 'PATIENT_GET_HEALTH_RECORD';
export const PATIENT_GET_DOCUMENT = 'PATIENT_GET_DOCUMENT';
export const PATIENT_CLEAR = 'PATIENT_CLEAR';
export const REPORT_CASE_CONSULT = 'REPORT_CASE_CONSULT';
export const REALTIME_SIGNAL = 'REALTIME_SIGNAL';
export const REALTIME_SIGNAL_GUEST = 'REALTIME_SIGNAL_GUEST';
export const WHITELABEL_SETTING = 'WHITELABEL_SETTING';
export const WHITELABEL_SETTING_THEME = 'WHITELABEL_SETTING_THEME';
export const CALL_QUEUE_ADD = 'CALL_QUEUE_ADD';
export const CALL_QUEUE_REMOVE = 'CALL_QUEUE_REMOVE';
